export function mapStateToProps(state) {
  return {
    faq: state.config.faq,
  };
}

export function mapDispatchToProps() {
  return {};
}
